<template>
  <v-expansion-panels
    v-if="hints && hints.data.length"
    class="mb-6"
  >
    <v-expansion-panel>
      <v-expansion-panel-header
        class="d-flex justify-start"
        expand-icon="mdi-menu-down"
      >
        <span>
          <v-icon color="red">mdi-alert</v-icon> U bazi postoje slični ili isti
          zapisi
        </span>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-list subheader>
          <v-subheader>Slični zapisi</v-subheader>

          <v-list-item v-for="item in hints.data" :key="item.id">
            <v-list-item-content>
              <v-list-item-title v-text="item.naziv"></v-list-item-title>
            </v-list-item-content>

            <v-list-item-icon v-if="isSelectable">
                <v-btn @click="select(item)" x-small color="primary">Odaberi</v-btn>
              </v-list-item-icon>
          </v-list-item>
        </v-list>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>
<script>
export default {
  props: {
    hints: {
      type: Object,
    },
    isSelectable: {
      type: Boolean,
      required: true,
    },
  },
  methods:{
      select(item) {
          this.$emit('selectItem', item)
      }
  }
};
</script>